import _regeneratorRuntime from "babel-runtime/regenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";


import * as utils from "@/tools/util";
import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";

var backfillOldData = function backfillOldData(_this) {
  var otherAgentlinkInfo = _.cloneDeepGet(_this, "oppBusiData.oldBusiData.otherAgentlinkInfo");
  if (!_.isEmpty(otherAgentlinkInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], otherAgentlinkInfo);
  }
};

var backfillHistoryData = function backfillHistoryData(_this) {
  var otherAgentlinkInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  if (!_.isEmpty(otherAgentlinkInfo)) {
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], otherAgentlinkInfo);
    _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], otherAgentlinkInfo);
  }
};

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  fields.POSITION.FIELD_CONTROL = "1";

  fields.RELATION_PATION.VALID_TYPE = "valAX[0, 50]";
  fields.RELATION_PATION.FIELD_CONTROL = "1";
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {

    initFieldConfig(_this);

    if (_this.$storage.getJsonSession(_this.$definecfg.IS_OPEN_ACCT_BIZ) == 0) {
      backfillOldData(_this);
    }
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var orgAgentInfo, oldAgentInfo, baseGroupId, baseModuleId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              orgAgentInfo = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH]);
              oldAgentInfo = _.get(params, "" + SAVE_PATH);
              ;
              baseGroupId = _this.userType == "1" ? "ORG_INFO_PAGE" : "MANAGER_INFO_PAGE", baseModuleId = _this.userType == "1" ? "BASIC_MODULE" : "MANAGER_OTHER_INFO";

              orgAgentInfo.CORP_ADDR = _this.groupDatas[baseGroupId][baseModuleId][0].FIELDS.CORP_ADDR.DEFAULT_VALUE;
              orgAgentInfo.ID_ZIP_CODE = _this.groupDatas[baseGroupId][baseModuleId][0].FIELDS.ID_ZIP_CODE.DEFAULT_VALUE;

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], orgAgentInfo);

              _.set(params, SAVE_PATH, _Object$assign({}, oldAgentInfo, orgAgentInfo));

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),

  validate: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validate(_x4) {
      return _ref2.apply(this, arguments);
    }

    return validate;
  }(),

  pageActivated: function pageActivated(_this, groupId) {
    var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;

    if (_this.userType == "1" && _.get(_this, "historyData.BIZ_DATA.BASE_INFO.PROF_INVESTOR_SOURCE") != "10" && _this.apptStatus < 4) {
      fields.MOBILE_TEL.IS_SHOW_BUTTON = true;
      fields.MOBILE_TEL.FIELD_BUTTON_TXT = "发送风险测评短信";
      fields.MOBILE_TEL.OLD_FIELD_BUTTON_TXT = "发送风险测评短信";
      fields.MOBILE_TEL.remainTime = 300;
    }
  },
  afterSave: function afterSave(_this, newData) {},
  beforeSkipBiz: function beforeSkipBiz(_this) {},

  "CHECK_POSITION": function CHECK_POSITION(_this, field, fieldData) {
    if (field.DEFAULT_VALUE != "") {
      if (field.DEFAULT_VALUE == "Z") {
        fieldData.POSITION_PATION.FIELD_CONTROL = "0";
      } else {
        fieldData.POSITION_PATION.FIELD_CONTROL = "1";
      }
    }
  },
  "CHECK_CORP_RELATION": function CHECK_CORP_RELATION(_this, field, fieldData) {
    if (field.DEFAULT_VALUE != "") {
      if (field.DEFAULT_VALUE == "2") {
        fieldData.RELATION_PATION.FIELD_CONTROL = "0";
        fieldData.RELATION_PATION.FIELD_REQUIRED = "1";
      } else {
        fieldData.RELATION_PATION.FIELD_CONTROL = "1";
        fieldData.RELATION_PATION.FIELD_REQUIRED = "0";
      }
    }
  }
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS420/bizOther/bizOtherAgentLinkInfoNode.js
// module id = 156
// module chunks = 2